export enum DamageSeverity {
    HIGH = 'HIGH',
    LOW = 'LOW',
    NONE = 'NONE'
}